import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';
import Entity from './Entity';
import Collectable from './Collectable';
import './Treasure.css';

export default class Treasure extends Component {

  state = {

    tooltip: null
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  render () {

    let tooltips = []

    let src = this.props.src;
    let manager = this.props.manager;
    let type = src.type || "treasure";

    return (
      <div className={"treasure-scene fight-scene " + ((src.type === "treasure" && !src.empty) || type === "altar" ? "dark-scene " : "") + (manager.controller.name)}>
        <div className={"game-treasure game-treasure-" + (src.type)}>
          <Entity static={ src.entity.static } src={ src.entity } layoutScale={1} onSelect={() => {}}/>
          <div className="treasure-collectables">
          {
            src.collectables.map((collectable,i) =>
              <Collectable
              onSelect={() => manager.run.room.treasure.take(i)}
              src={collectable}
              id={"treasure-collectable-" + i}
              key={"treasure-collectable-" + i}
              />
            )
          }
          </div>
        </div>
      </div>
    );
  }
}

